<template>
  <div class="pt-5">
    <slot />
  </div>
</template>
